export const COPYRIGHT_TM = 169

export const SELECT_COUNTRY = 'Select your country'
